import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { FC, lazy, Suspense } from 'react'
import { EnhancedKPIViewContainerProps } from './EnhancedKPIViewContainer'

const EnhancedKPIViewContainerLazy: FC<EnhancedKPIViewContainerProps> = lazy(
  () => import('./EnhancedKPIViewContainer')
)

const EnhancedKPIViewContainer: FC<EnhancedKPIViewContainerProps> = props => {
  return (
    <Suspense fallback={FallbackComponent}>
      <EnhancedKPIViewContainerLazy {...props} />
    </Suspense>
  )
}

export default EnhancedKPIViewContainer
